var isArray = Array.isArray;
var isObject = require('./../support/isObject');

module.exports = isJSONGraphEnvelope;

function isJSONGraphEnvelope(envelope) {
    return isObject(envelope) && isArray(envelope.paths) && (
        isObject(envelope.jsonGraph) ||
        isObject(envelope.jsong) ||
        isObject(envelope.json) ||
        isObject(envelope.values) ||
        isObject(envelope.value)
    );
}



// WEBPACK FOOTER //
// ./lib/support/isJSONGraphEnvelope.js